import { apolloCache } from '../src/createClient';

export function getApolloCache() {
	return apolloCache;
}
